// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2-8Vw","actions":"GroupTable_actions__2er6D","deleteModalFooter":"GroupTable_deleteModalFooter__2pHF4"};